







































































import Vue from 'vue'

import Tooltip from '@/common/components/Tooltip.vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import BaseImage from '@/common/components/BaseImage.vue'

import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import {
  ProductState,
  ProductSku,
  ProductEstimate,
  ProductInfo
} from '@/product/types'

const MOBILE_DEFAULT_VISIBLE_ITEMS = 10

export default Vue.extend({
  components: {
    Tooltip,
    BaseImage,
    SectionTitle
  },
  data(): {
    optionsEl: HTMLElement | null
    showModalEditPattern: boolean
    isExpanded: boolean
  } {
    return {
      optionsEl: null,
      showModalEditPattern: false,
      isExpanded: false
    }
  },
  computed: {
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    placeholderSquare() {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    storeState(): ProductState {
      return this.$store.state
    },
    productSku(): ProductSku {
      return this.storeState.productDetail.sku
    },
    productEstimate(): ProductEstimate {
      return this.storeState.estimate
    },
    productInfo(): ProductInfo {
      return this.storeState.productDetail.product
    },
    firstSelectedOptionDisplayName(): string | undefined {
      return this.productEstimate.firstSelectedOption?.displayName
    },
    isExpansible(): boolean {
      return (
        this.productSku.firstOptions &&
        this.productSku.firstOptions.length > MOBILE_DEFAULT_VISIBLE_ITEMS
      )
    }
  },
  mounted() {
    this.optionsEl = this.$el.getElementsByClassName(
      'pr-ProductOptions_SectionPrintOption'
    )[0] as HTMLElement
  },
  methods: {
    onChangeBasicSelection(fieldName: string, id: string) {
      this.$store.commit('setSelectedId', { fieldName, id })
      this.$emit('onChangeProductPsi', {
        _disabledLoading: true,
        loadImageView: true
      })
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  }
})
